import { useState } from "react";
import { useAutoRefresh } from "./useAutoRefresh";

/** Um relogio por painel, nao por card. Voltar da aba recalcula imediatamente;
 * payload igual, erro HTTP e ausencia de SSE nao congelam a idade da leitura.
 */
export function useObservationClock(enabled: boolean, lastSuccessAt: Date | null): Date {
  const [tick, setTick] = useState(() => new Date());
  useAutoRefresh({ enabled, intervalMs: 5_000, onRefresh: () => setTick(new Date()) });
  return lastSuccessAt && lastSuccessAt > tick ? lastSuccessAt : tick;
}
